module.exports = "{{#if maxLength}} <textarea class=\"textarea js-textarea\" placeholder={{placeholder}} maxlength={{maxLength}}></textarea> {{else}} <textarea class=\"textarea js-textarea\" placeholder={{placeholder}}></textarea> {{/if}}";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/templates/textAreaEditor.hbs
// module id = 694
// module chunks = 0